import React from 'react';
import HandCube from '../assets/images/olav-ahrens-rotne-4Ennrbj1svk-unsplash.png';
import AboutImg from '../assets/images/about-img.jpg'
import DesignedForYou from '../assets/videos/vid-design-for-you.mp4';
import { useRef, useEffect } from 'react';

export default function AboutSec() {

  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Video is in view, start autoplay
            videoElement.play();
          } else {
            // Video is out of view, pause autoplay
            videoElement.pause();
          }
        });
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    // Start observing the video element
    observer.observe(videoElement);

    // Clean up observer when component unmounts
    return () => observer.disconnect();
  }, []);


    return (
    <>

  <div className="d-flex justify-content-center w-100 vid-bg position-relative">
        <video ref={videoRef} 
          className="img-fluid"
          autoPlay
          loop
          muted
          playsInline
          controlsList="nodownload"
          poster="https://d64is2qkxbhv3.cloudfront.net/website-assets/applift/img/design-for-you/thumbnail-design-for-you.png"
          onTouchStart={() => videoRef.current.play()}
        >
          <source
            src={DesignedForYou}
            type="video/webm"
          />
          <source
            src={DesignedForYou}
            type="video/mp4"
          />
        </video>
    
    <div className="vid-overlay p-lg-5 d-flex justify-content-end flex-column">
    <div className='container'>
        <div className='row videoDesc'>
        <h2 class="display-5 fw-bold text-white">Designed for managed media buying </h2>
        <h3 class="display-5 fw-bold text-white">services with self-serve capabilities</h3>
    </div>
    </div>
    </div>
  </div>
      
</>
)
}